export default __webpack_public_path__ + "static/media/game-dev.20147858.svg";